import { Link } from 'react-router-dom';
import BoloLogo from '@/components/base/BoloLogo';

export default function Footer() {
  return (
    <footer className="bg-[#272727] text-[#e9eae4]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-2">
            <div className="mb-5">
              <BoloLogo className="h-10 w-auto" variant="dark" />
            </div>
            <p className="text-[#e9eae4]/60 text-base max-w-md font-barlow">
              Trend intelligence for the modern reseller. Every Thursday.
            </p>
          </div>

          <div>
            <h4 className="text-[#e9eae4] text-lg font-semibold mb-4 font-antonio tracking-wide">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-[#e9eae4]/60 hover:text-[#e9eae4] transition-colors text-base cursor-pointer font-barlow">
                  Home
                </Link>
              </li>
              <li>
                <a
                  href="https://theboloreport.substack.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#e9eae4]/60 hover:text-[#e9eae4] transition-colors text-base cursor-pointer font-barlow"
                >
                  Reports
                </a>
              </li>
              <li>
                <Link to="/about" className="text-[#e9eae4]/60 hover:text-[#e9eae4] transition-colors text-base cursor-pointer font-barlow">
                  About
                </Link>
              </li>
              <li>
                <Link to="/subscribe" className="text-[#e9eae4]/60 hover:text-[#e9eae4] transition-colors text-base cursor-pointer font-barlow">
                  Subscribe
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[#e9eae4] text-lg font-semibold mb-4 font-antonio tracking-wide">Connect</h4>
            <div className="flex space-x-4">
              <a
                href="https://theboloreport.substack.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-[#e9eae4]/20 rounded-full hover:border-[#e9eae4]/50 hover:bg-[#e9eae4]/5 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-lg"></i>
              </a>
              <a
                href="https://theboloreport.substack.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-[#e9eae4]/20 rounded-full hover:border-[#e9eae4]/50 hover:bg-[#e9eae4]/5 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#e9eae4]/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-[#e9eae4]/50 text-sm font-barlow">
              © 2025 The BOLO Report. All rights reserved.
            </p>
            <a
              href="https://theboloreport.substack.com/subscribe?utm_source=menu&simple=true&next=https%3A%2F%2Ftheboloreport.substack.com%2F"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#4d4d31] text-[#e9eae4] px-8 py-3 rounded-full text-base font-semibold hover:bg-[#3d3d25] transition-all flex items-center space-x-2 whitespace-nowrap cursor-pointer font-barlow tracking-wide"
            >
              <span>Subscribe Now</span>
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
